import { get, post, remove } from '../common/http';

class SlotApi {

    static async getCounts() {
        const res = await get('/api/slots/counts');
        console.log('res', res);
        return res;
    }

    static async getSlotList(params) {
        const { page, count, keyword, state, orderBy, orderType } = params;
        const res = await get(`/api/slots?page=${page}&count=${count}&keyword=${keyword}&state=${state}&orderBy=${orderBy}&orderType=${orderType}`);
        return res;
    }

    static async addSlot(params) {
        const res = await post('/api/slots', params);
        return res;
    }

    static async deleteSlot(ids) {
        // ids가 배열이면 쿼리 파라미터로 변환
        const idParams = Array.isArray(ids) 
            ? ids.map(id => `ids=${id}`).join('&')
            : `ids=${ids}`;
        
        const res = await remove(`/api/slots?${idParams}`);
        return res;
    }

    static async extendSlot(params) {
        const res = await post('/api/slots/extend', params);
        return res;
    }

    static async approveSlot(ids) {
        const res = await post('/api/slots/approve', { ids });
        return res;
    }
}

export default SlotApi; 